import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetTestConfigParams,
  GetTestConfigsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: GetTestConfigParams
  children?: (data?: GetTestConfigsResponse) => ReactElement
  onSuccess?: (data: GetTestConfigsResponse) => void
  onError?: (error: Error) => void
}

const GetTestConfigsRequest = ({
  params,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/test_configurations`

  const { requestParams } = useGetParamsWithSpaceId<GetTestConfigParams|undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetTestConfigsRequest
